import {
  getCheckoutBackupData,
  postCheckoutBackupData,
} from '../../api/checkoutBackup.api'
import { logger } from '../logger'
import { type CheckoutBackupPayload } from './checkoutBackup.types'
import { restoreSingleProduct } from 'components/Checkout/checkoutSaver'
import omit from 'lodash/omit'

function sanitizeCheckoutSingleProductForLogging(
  checkoutSingleProduct: any
): any {
  if (!checkoutSingleProduct) return checkoutSingleProduct

  // Omit cropParams from orderTiles to reduce log size
  if (
    checkoutSingleProduct.orderTiles &&
    Array.isArray(checkoutSingleProduct.orderTiles)
  ) {
    return {
      ...checkoutSingleProduct,
      orderTiles: checkoutSingleProduct.orderTiles.map((tile: any) =>
        omit(tile, ['cropParams'])
      ),
    }
  }

  return checkoutSingleProduct
}

function stringifyWithoutCropParams(value: object): string {
  return JSON.stringify(value, (key, nestedValue: unknown) =>
    key === 'cropParams' ? undefined : nestedValue
  )
}

export async function saveCheckoutBackup(
  paymentIntentId: string,
  createOrderParams: object
): Promise<void> {
  const checkoutSingleProduct = restoreSingleProduct()
  const sanitizedCheckoutSingleProduct =
    sanitizeCheckoutSingleProductForLogging(checkoutSingleProduct)

  logger.info('Saving checkout backup data', {
    paymentIntentId,
    createOrderParams: stringifyWithoutCropParams(createOrderParams),
    checkoutSingleProduct: sanitizedCheckoutSingleProduct,
  })
  await postCheckoutBackupData(
    paymentIntentId,
    createOrderParams,
    checkoutSingleProduct
  )
  logger.info('Checkout backup data saved', {
    paymentIntentId,
    createOrderParams: stringifyWithoutCropParams(createOrderParams),
    checkoutSingleProduct: sanitizedCheckoutSingleProduct,
  })
}

export async function restoreCheckoutBackup(
  paymentIntentId: string
): Promise<CheckoutBackupPayload | null> {
  if (paymentIntentId) {
    try {
      logger.info('Restoring checkout backup data', { paymentIntentId })
      const checkoutBackupData = await getCheckoutBackupData(paymentIntentId)
      const { createOrderParams, checkoutSingleProduct } = checkoutBackupData

      logger.info('Found checkout backup data', {
        paymentIntentId,
        createOrderParams: stringifyWithoutCropParams(createOrderParams),
        checkoutSingleProduct: sanitizeCheckoutSingleProductForLogging(
          checkoutSingleProduct
        ),
      })

      return checkoutBackupData
    } catch (error) {
      logger.error('Error fetching checkout backup data:', error, {
        paymentIntentId,
      })
    }
  }
  return null
}
